import * as yup from 'yup';

const validators = (__) => () => {
    return (
        yup.object({
            codFactura: yup.string().required(__(`form.codFactura.error`)),
            description: yup.string().required(__(`form.description.error`)),
        })
    )
}

export default validators
